// extracted by mini-css-extract-plugin
export default {"cell-container":"CellDeployModuleName_cell-container__pJhh1"};